import React, { Component } from "react"
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from "react-intl"
import { AppContext, Features } from "@lightspeed-invoicing/core-client/frontend"
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx"
import ConfirmButton from "../common/button/confirmbutton.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import LoadingSpinner from "../common/spinner/loading.component.jsx"
import { Link, Redirect } from "react-router-dom"
import ActionButton from "../common/button/actionbutton.component.jsx"
import PricingTableModal from "../quote/analytics/pricingtablemodal.component.jsx"
import InlineEditUser from "../common/inline-edit/user.component.jsx"
import InlineEditTemplate from "../common/inline-edit/template.component.jsx"
import PriceListStatusBadge from "../price-list/status.component.jsx"
import DateDisplayComponent from "../common/inline-edit/component/DateDisplayComponent"
import PriceList from "../state/price-list/PriceList"
import priceListMessages from "./helpers/priceListMessages"
import PriceListLimitRuleDisplayComponent from "./components/PriceListLimitRuleDisplayComponent"
import { LIMIT_RULE_KEY } from "../state/price-list/ruleStrategyKeys"
import BulkCreateModalWrapper from "./modal/BulkCreateModalWrapper"
import Proposal from "../state/proposal/Proposal"
import OrderAttemptSection from "./sections/OrderAttemptSection"
import GlobalHelper from "../common/GlobalHelper"
import ButtonWrapper from "../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"
import { getPriceListName } from "../name-helpers/priceListNameHelper"
import { capitalize } from "../name-helpers/nameFormatter"
import NewInvoiceModal from "../invoice/newmodal.component"
import PriceListOrderListingComponent from "./PriceListOrderListingComponent"
import { generateOptions } from "../quote/utils/QuoteStatusOrderForm"
import NewPriceListModal from "./components/NewPriceListModal"
import PriceListService from "../state/price-list/PriceListService"
import { updatePriceList } from "../state/price-list/priceListActions"
import { connect } from "react-redux"
import { Button } from "react-bootstrap"

const messages = defineMessages({
    quote: {
        id: "price_list.analytics.created_quotes",
        defaultMessage: "Quotes"
    },
    invoice: {
        id: "price_list.analytics.created_invoices",
        defaultMessage: "Invoices"
    },
    "credit-memo": {
        id: "price_list.analytics.created_deposits",
        defaultMessage: "Deposits"
    }
})

class PriceListAnalytics extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            priceList: this.props.priceList || null,
            proposal: this.props.proposal || null,
            onRefresh: this.props.onRefresh || function() {},
            onEdit: this.props.onEdit || function() {},
            redirect: "",
            modal: "",
            statusLoading: false,
            moreLoading: false,
            isEditable: this.props.priceList && this.props.priceList.attributes.deletedAt === "",
            accountLimit: null,
            buttonCopyLabel: "",
            showBulkCreateModal: false
        }
        this.handleRefreshQuote = this.handleRefreshQuote.bind(this)
        this.archive = this.archive.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.handleOnEdit = this.handleOnEdit.bind(this)
        this.duplicate = this.duplicate.bind(this)
        this.activate = this.activate.bind(this)
        this.deactivate = this.deactivate.bind(this)
        this.openPricingTableModal = this.openPricingTableModal.bind(this)
        this.copyLink = this.copyLink.bind(this)
        this.clearCopyLink = this.clearCopyLink.bind(this)
        this.toggleBulkCreateModal = this.toggleBulkCreateModal.bind(this)
        this.openInvoiceCreationModal = this.openInvoiceCreationModal.bind(this)
        this.closeInvoiceCreationModal = this.closeInvoiceCreationModal.bind(this)
        this.markAsDone = this.markAsDone.bind(this)
        this.canBeInvoiced = this.canBeInvoiced.bind(this)
        this.onHidePriceListModal = this.onHidePriceListModal.bind(this)
        this.createPriceList = this.createPriceList.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            priceList: nextProps.priceList || null,
            proposal: nextProps.proposal || null,
            isEditable: nextProps.priceList && nextProps.priceList.attributes.deletedAt === ""
        })
    }

    componentDidMount() {
        AppContext.getApiClient()
            .get("/account-limits")
            .then(res => {
                this.setState({
                    accountLimit: res
                })
            })
    }

    handleRefreshQuote() {
        this.state.onRefresh(this.state.priceList.id)
    }

    handleOnEdit(e) {
        e.preventDefault()
        this.state.onEdit(this.state.priceList.id)
    }

    archive(event) {
        event.preventDefault()
        return AppContext.getApiClient()
            .delete("/price-lists/" + this.state.priceList.id, {})
            .then(q => {
                this.handleRefreshQuote()
            })
    }

    canBeInvoiced() {
        return (
            ["active", "completed"].includes(this.state.priceList.attributes.status) &&
            !this.state.priceList.attributes.invoiceReferenceId &&
            this.state.accountLimit &&
            GlobalHelper.isDocumentSupported("invoices") &&
            this.state.priceList.attributes.objectType === "credit-memo" &&
            this.state.priceList.attributes.numberOfOrders > 0
        )
    }

    handleCloseModal() {
        this.setState({
            modal: ""
        })
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ""
        })
        this.handleRefreshQuote()
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            modal: (
                <ProposalPreviewModal
                    onClose={this.handleCloseModal}
                    hash={this.state.proposal.attributes.hash}
                    pdfLink={this.state.proposal.attributes.variables.document.pdfUri}
                    proposalType={"price-list"}
                    publicLink={this.state.proposal.attributes.publicLink}
                />
            )
        })
    }

    openPricingTableModal(e) {
        e.preventDefault()
        this.setState({
            modal: <PricingTableModal object={this.state.priceList} onClose={this.handleCloseModal} />
        })
    }

    activate(event) {
        event.preventDefault()
        AppContext.getApiClient()
            .post("/price-lists/" + this.state.priceList.id + "/activate", {})
            .then(res => {
                this.handleRefreshQuote()
            })
    }

    deactivate(event) {
        event.preventDefault()
        AppContext.getApiClient()
            .post("/price-lists/" + this.state.priceList.id + "/deactivate", {})
            .then(res => {
                this.handleRefreshQuote()
            })
    }

    markAsDone(event) {
        event.preventDefault()
        AppContext.getApiClient()
            .post("/price-lists/" + this.state.priceList.id + "/complete", {})
            .then(res => {
                this.handleRefreshQuote()
            })
    }

    createPriceList = async (title, objectType, creditMemoContactReceiverId) => {
        this.setState({
            statusLoading: true
        })
        await PriceListService.DuplicatePriceList(this.props.priceList.id, {
            title: title,
            objectType: objectType,
            creditMemoContactReceiverId
        }).then(priceList => {
            this.setState(
                {
                    statusLoading: false,
                    modal: "",
                    redirect: <Redirect to={`/price-lists/${priceList.getId()}/edit`} />
                },
                () => this.props.updatePriceList(priceList)
            )
        })
    }

    onHidePriceListModal(event) {
        event?.preventDefault()
        this.setState({
            statusLoading: false,
            modal: ""
        })
    }

    duplicate = event => {
        event.preventDefault()
        this.setState({
            modal: (
                <NewPriceListModal
                    show={true}
                    onHide={this.onHidePriceListModal}
                    onCreate={this.createPriceList}
                    title={this.props.priceList.attributes.title}
                    objectType={this.props.priceList.objectType}
                    hideSelect={false}
                    isLoading={this.state.statusLoading}
                />
            )
        })
    }

    copyLink(e) {
        e.preventDefault()
        let copyText = document.getElementById("proposalPublicLink")
        copyText.select()
        copyText.setSelectionRange(0, 99999) /*For mobile devices*/
        document.execCommand("copy")
        this.setState({
            buttonCopyLabel: <FormattedMessage id="price_list.analytics.link_copied_btn" defaultMessage="Link Copied!" />
        })
        setTimeout(this.clearCopyLink, 2000)
    }

    clearCopyLink() {
        this.setState({
            buttonCopyLabel: ""
        })
    }

    getObjectTypeDisplayTabs() {
        const objType = this.state.priceList.attributes.objectType
        switch (objType) {
            case "quote":
                return [objType]
            case "invoice":
                return [objType]
            case "credit-memo":
                return [objType, "invoice"]
        }
    }

    getTemplateLabelByObjectType() {
        switch (this.state.priceList.attributes.objectType) {
            case "quote":
                return <FormattedMessage id="price_list.edit.details.quote_template_label" defaultMessage="Quote template" />
            case "invoice":
                return <FormattedMessage id="price_list.edit.details.invoice_template_label" defaultMessage="Invoice template" />
            case "credit-memo":
                return (
                    <FormattedMessage
                        id="price_list.edit.details.credit_memo_template_label"
                        defaultMessage="Credit memo template"
                    />
                )
        }
    }

    toggleBulkCreateModal() {
        this.setState({
            showBulkCreateModal: !this.state.showBulkCreateModal
        })
    }

    closeInvoiceCreationModal(invoiceId) {
        this.setState({
            modal: invoiceId ? <Redirect to={"/invoices/" + invoiceId + "/edit"} /> : ""
        })
    }

    objectTypeIsQuote() {
        return this.state.priceList.attributes.objectType == "quote"
    }

    getStatusLabel() {
        return generateOptions(this.props.intl).find(i => i.value === this.state.priceList.attributes.docGeneratedStatus).label
    }
    openInvoiceCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: (
                <NewInvoiceModal
                    warningMessage={"invoicing_price_list_warning"}
                    sellerId={this.state.priceList.attributes.sellerId}
                    priceListId={this.state.priceList.id}
                    onClose={this.closeInvoiceCreationModal}
                    contactId={this.state.priceList.attributes.creditMemoContactReceiverId}
                />
            )
        })
    }

    render() {
        if (!this.state.priceList || !this.state.proposal) {
            return <div />
        }

        const canActivate =
            ["inactive", "completed"].includes(this.state.priceList.attributes.status) &&
            !this.state.priceList.attributes.invoiceReferenceId

        const conversionRate =
            parseInt(this.state.priceList.attributes.numberOfOrders) / parseInt(this.state.proposal.attributes.numberOfVisits)

        const priceList = new PriceList(this.state.priceList)
        return (
            <div className={"row analytics-page py-3 mb-5"}>
                {this.state.showBulkCreateModal && (
                    <BulkCreateModalWrapper
                        objectType={this.state.priceList.attributes.objectType}
                        show={this.state.showBulkCreateModal}
                        onHide={this.toggleBulkCreateModal}
                        proposal={new Proposal(this.state.proposal)}
                        priceListId={this.state.priceList.id}
                    />
                )}
                {this.state.redirect}
                {this.state.modal}
                <div className="col-12 ui-module">
                    <div className={"row"}>
                        <div className={"col-12 col-md-6 border-right"}>
                            <h3 className={"m-0 d-flex align-items-center"}>
                                <FormattedMessage
                                    id="price_list.analytics.title"
                                    defaultMessage="{priceList} {number}"
                                    values={{
                                        number: this.state.priceList.attributes.identifier,
                                        priceList: capitalize(getPriceListName(this.props.intl))
                                    }}
                                />
                                <h6 className="ml-2 d-inline mb-0">
                                    <PriceListStatusBadge
                                        isDisabled={this.state.priceList.attributes.isDisabled}
                                        status={this.state.priceList.attributes.status}
                                    />
                                </h6>
                            </h3>
                            <div className={"w-100"}>
                                <div className="form-group mb-0 pl-0">
                                    <label className="pl-0 col-12 col-form-label custom-form-label">
                                        <FormattedMessage id="price_list.edit.details.title_label" defaultMessage="Title" />
                                    </label>
                                    <div className="pl-0 col-12">{this.state.priceList.attributes.title}</div>
                                </div>
                                <div className="form-group mb-0 pl-0">
                                    <label className="pl-0 col-12 col-form-label custom-form-label">
                                        {this.getTemplateLabelByObjectType()}
                                    </label>
                                    <div className="pl-0 col-12">
                                        <InlineEditTemplate editable={false} value={this.state.priceList.attributes.templateId} />
                                    </div>
                                </div>
                                {this.state.priceList.attributes.orderReferenceId && (
                                    <div>
                                        <label className="pl-0 col-12 col-form-label custom-form-label">
                                            <FormattedMessage
                                                id="price_list.edit.details.order_reference_id"
                                                defaultMessage="Order to pay"
                                            />
                                        </label>
                                        <Link to={`/orders/${this.state.priceList.attributes.orderReferenceId}/edit`}>
                                            {this.state.priceList.attributes.orderReferenceLabel}
                                        </Link>
                                    </div>
                                )}
                                {this.state.priceList.attributes.invoiceReferenceId && (
                                    <div>
                                        <label className="pl-0 col-12 col-form-label custom-form-label">
                                            <FormattedMessage
                                                id="price_list.edit.details.invoice_reference_id"
                                                defaultMessage="Invoice"
                                            />
                                        </label>
                                        <Link to={`/invoices/${this.state.priceList.attributes.invoiceReferenceId}/edit`}>
                                            {this.state.priceList.attributes.invoiceReferenceLabel}
                                        </Link>
                                    </div>
                                )}
                            </div>

                            {priceList.getValidationStrategyKey() && (
                                <div className={"w-100"}>
                                    <label className="col-form-label custom-form-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="price_list.edit.price_list_rules_label"
                                                defaultMessage="Rules"
                                            />
                                        </strong>
                                    </label>
                                    <p className={"m-0"}>
                                        {this.props.intl.formatMessage(priceListMessages[priceList.getValidationStrategyKey()])}
                                    </p>

                                    {priceList.getValidationStrategyKey() === LIMIT_RULE_KEY && (
                                        <PriceListLimitRuleDisplayComponent priceList={priceList} />
                                    )}
                                </div>
                            )}

                            {priceList.getCustomerType() && (
                                <div className={"w-100"}>
                                    <label className="col-form-label custom-form-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="price_list.edit.customer_type_label"
                                                defaultMessage="Customer type"
                                            />
                                        </strong>
                                    </label>
                                    <p className={"m-0"}>{priceList.getCustomerType()}</p>
                                </div>
                            )}

                            {priceList.getCustomerTags().length > 0 && (
                                <div className={"w-100"}>
                                    <label className="col-form-label custom-form-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="price_list.edit.customer_tag_label"
                                                defaultMessage="Customer Tag(s)"
                                            />
                                        </strong>
                                    </label>
                                    <p className={"m-0"}>{priceList.getCustomerTags().join(", ")}</p>
                                </div>
                            )}
                            {this.objectTypeIsQuote() && (
                                <div className={"w-100"}>
                                    <label className="col-form-label custom-form-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="price_list.edit.details.default_quote_status_label"
                                                defaultMessage="Default Quote Status"
                                            />
                                        </strong>
                                    </label>
                                    <p className={"m-0"}>{this.getStatusLabel()}</p>
                                </div>
                            )}
                            {
                                <div className={"w-100"}>
                                    <label className="col-form-label custom-form-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="price_list.edit.details.send_confirmation_email"
                                                defaultMessage="Send Confirmation Email"
                                            />
                                        </strong>
                                    </label>
                                    <p className={"m-0"}>
                                        {!priceList.getNotificationDisabled() ? (
                                            <FormattedMessage
                                                id="price_list.edit.details.send_confirmation_email_enabled"
                                                defaultMessage="Enabled"
                                            ></FormattedMessage>
                                        ) : (
                                            <FormattedMessage
                                                id="price_list.edit.details.send_confirmation_email_desabled"
                                                defaultMessage="Disabled"
                                            ></FormattedMessage>
                                        )}
                                    </p>
                                </div>
                            }
                        </div>

                        <div className={"col-12 col-md-6 d-flex"}>
                            <div className={"w-100 text-right"}>
                                <div className={"w-100"}>
                                    <label className="col-form-label custom-form-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="price_list.analytics.assign_to_label"
                                                defaultMessage="Assigned to"
                                            />
                                        </strong>
                                    </label>
                                </div>
                                <p className={"m-0"}>
                                    <Icon value={"user"} />{" "}
                                    <InlineEditUser
                                        editable={false}
                                        value={this.state.priceList.attributes.seller.attributes.name}
                                        userId={this.state.priceList.attributes.seller.id}
                                    />
                                </p>

                                {this.state.priceList.attributes.location && (
                                    <>
                                        <div className={"w-100"}>
                                            <label className="col-form-label custom-form-label pt-2">
                                                <strong>
                                                    <FormattedMessage
                                                        id="price_list.analytics.location_label"
                                                        defaultMessage="Location"
                                                    />
                                                </strong>
                                            </label>
                                        </div>
                                        <p className={"m-0"}>
                                            <Icon value={"map-marker-alt"} />{" "}
                                            {this.state.priceList.attributes.location.attributes.name}
                                        </p>
                                    </>
                                )}

                                {this.state.priceList.attributes.creditMemoContactReceiver && (
                                    <>
                                        <div className={"w-100"}>
                                            <label className="col-form-label custom-form-label pt-2">
                                                <strong>
                                                    <FormattedMessage
                                                        id="price_list.analytics.credit_memo_receiver_label"
                                                        defaultMessage="Credit memo receiver"
                                                    />
                                                </strong>
                                            </label>
                                        </div>{" "}
                                        <p className={"m-0"}>
                                            <Icon value={"piggy-bank"} />{" "}
                                            {this.state.priceList.attributes.creditMemoContactReceiver.attributes.name}
                                        </p>
                                    </>
                                )}

                                {priceList.getExpirationDate() && (
                                    <div className={"w-100"}>
                                        <label className="col-form-label custom-form-label pt-2">
                                            <strong>
                                                <FormattedMessage
                                                    id="quote.analytics.expiration_date_label"
                                                    defaultMessage="Expiration date"
                                                />
                                            </strong>
                                        </label>
                                        <p className={"m-0"}>
                                            <DateDisplayComponent date={priceList.getExpirationDate()} />
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 px-0">
                    <h4 className="p-0">
                        <Icon value={"shopping-cart"} className={"mr-2"} />
                        <FormattedMessage id="price_list.analytics.orders" defaultMessage="Orders" />
                    </h4>
                </div>
                <div className="col-12 ui-module">
                    {this.state.priceList.attributes.status === "inactive" ? (
                        <div className={"w-100 pb-2"}>
                            <Icon value={"info"} />
                            <FormattedMessage
                                id="price_list.analytics.orders_inactive"
                                defaultMessage="The {priceList} is inactive. No more order will be created."
                                values={{
                                    priceList: getPriceListName(this.props.intl)
                                }}
                            />
                        </div>
                    ) : (
                        ""
                    )}
                    <div className={"w-100 d-flex flex-wrap"}>
                        <div className={"mr-2 bg-custom-primary px-3"}>
                            <div className={"w-100"}>
                                <label className="col-form-label custom-form-label pt-2 text-white">
                                    <strong>
                                        <FormattedMessage
                                            id="price_list.analytics.total_amount_label"
                                            defaultMessage="Total amount"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h2 className={"m-0"}>
                                <FormattedNumber
                                    value={this.state.priceList.attributes.amountOfOrders}
                                    style={"currency"}
                                    currency={this.state.priceList.attributes.currency}
                                />
                            </h2>
                        </div>
                        <div className={"mr-2 bg-secondary px-3"}>
                            <div className={"w-100"}>
                                <label className="col-form-label custom-form-label py-2 text-white">
                                    <strong>
                                        <FormattedMessage
                                            id="price_list.analytics.number_of_orders_label"
                                            defaultMessage="Number of orders"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h5 className={"m-0 text-white border-0"}>{this.state.priceList.attributes.numberOfOrders}</h5>
                        </div>
                        <div className={"mr-2 bg-secondary px-3"}>
                            <div className={"w-100"}>
                                <label className="col-form-label custom-form-label py-2 text-white">
                                    <strong>
                                        <FormattedMessage
                                            id="price_list.analytics.number_of_visits_label"
                                            defaultMessage="Number of visits"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h5 className={"m-0 text-white border-0"}>{this.state.proposal.attributes.numberOfVisits}</h5>
                        </div>
                        <div className={"mr-2 bg-secondary px-3"}>
                            <div className={"w-100"}>
                                <label className="col-form-label custom-form-label py-2 text-white">
                                    <strong>
                                        <FormattedMessage
                                            id="price_list.analytics.conversion_rate_label"
                                            defaultMessage="Conversion rate"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h5 className={"m-0 text-white border-0"}>
                                <FormattedNumber style="percent" value={conversionRate ? conversionRate : 0} />
                            </h5>
                        </div>
                        <div className={"mr-2"}>
                            <div className={"mb-2 w-100"}>
                                <a
                                    target={"_blank"}
                                    href={"#"}
                                    className={"btn btn-sm btn-outline-primary"}
                                    onClick={this.openPricingTableModal}
                                    rel="noreferrer"
                                >
                                    <Icon value={"dollar-sign"} />
                                    <FormattedMessage id="price_list.analytics.pricing_table_btn" defaultMessage="Show details" />
                                </a>
                            </div>
                            <div className={" w-100"}>
                                <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"} onClick={this.openPreview}>
                                    <Icon value={"eye"} className={"mr-1"} />
                                    <FormattedMessage id="price_list.analytics.preview_btn" defaultMessage="Preview" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={"w-100 border-bottom mt-3"}></div>
                    <div className={"w-100 d-flex mt-3 justify-content-center"}>
                        <div className={"mr-2 w-50"}>
                            <input
                                id={"proposalPublicLink"}
                                className="form-control form-control-lg"
                                type="text"
                                value={this.state.proposal.attributes.publicLink}
                            />
                        </div>
                        <div className={"mr-2"}>
                            <button
                                className={"btn btn-lg " + (this.state.buttonCopyLabel ? "btn-success" : "btn-primary")}
                                onClick={this.copyLink}
                            >
                                <Icon value={"copy"} className={"mr-1"} />
                                {this.state.buttonCopyLabel ? (
                                    this.state.buttonCopyLabel
                                ) : (
                                    <FormattedMessage id="price_list.analytics.copy_link_btn" defaultMessage="Copy Link" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-12 px-0 ">
                    {this.getObjectTypeDisplayTabs().map((objectType, index) => {
                        return (
                            <div className={index > 0 ? "mt-4" : ""}>
                                <h4 className="p-0 m-0">{this.props.intl.formatMessage(messages[objectType])}</h4>
                                <PriceListOrderListingComponent
                                    priceListObjectType={objectType}
                                    priceListId={priceList.getId()}
                                />
                            </div>
                        )
                    })}
                </div>
                <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                    <div className={"col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4"}>
                        <div className="col-12 ui-module sticky-bottom-module">
                            <div className="row justify-content-end">
                                {this.state.isEditable ? (
                                    <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                        <div className={"d-flex"}>
                                            <div className={""}>
                                                <button
                                                    className={"btn btn-sm btn-outline-primary mr-2 mb-2"}
                                                    onClick={this.openPreview}
                                                >
                                                    <Icon value={"eye"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="price_list.analytics.preview_btn"
                                                        defaultMessage="Preview"
                                                    />
                                                </button>
                                                <a
                                                    className={"btn btn-sm btn-outline-primary mr-2 mb-2"}
                                                    href={this.state.proposal.attributes.publicLink}
                                                    target={"_blank"}
                                                    rel="noreferrer"
                                                >
                                                    <Icon value={"external-link-alt"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="price_list.analytics.open_price_list_btn_label"
                                                        defaultMessage="Open {priceList}"
                                                        values={{
                                                            priceList: getPriceListName(this.props.intl)
                                                        }}
                                                    />
                                                </a>
                                            </div>

                                            <div className="mr-2 mb-2 ">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    type="button"
                                                    id="dropdownMoreButton"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    {!this.state.moreLoading ? (
                                                        <Icon value={"ellipsis-h"} className={"mr-1"} />
                                                    ) : (
                                                        <LoadingSpinner height={15} width={3} className="px-5" />
                                                    )}
                                                </button>

                                                <div className="dropdown-menu" aria-labelledby="dropdownMoreButton">
                                                    <Button className="dropdown-item" href="#" onClick={this.duplicate}>
                                                        <Icon value={"clone"} className={"mr-1"} />
                                                        <FormattedMessage
                                                            id="price_list.analytics.duplicate_btn"
                                                            defaultMessage="Duplicate"
                                                        />
                                                    </Button>
                                                    {["active"].includes(this.state.priceList.attributes.status) && (
                                                        <button
                                                            className="btn btn-primary dropdown-item"
                                                            onClick={this.toggleBulkCreateModal}
                                                        >
                                                            <Icon value={"copy"} className={"mr-1"} />
                                                            <FormattedMessage
                                                                id="price_list.analytics.bulk_create_btn"
                                                                defaultMessage="Bulk create"
                                                            />
                                                        </button>
                                                    )}

                                                    {!["completed"].includes(this.state.priceList.attributes.status) && (
                                                        <a className="dropdown-item" href="#" onClick={this.handleOnEdit}>
                                                            <Icon value={"pen"} className={"mr-1"} />
                                                            <FormattedMessage
                                                                id="price_list.analytics.edit_btn"
                                                                defaultMessage="Edit"
                                                            />
                                                        </a>
                                                    )}

                                                    <ConfirmButton
                                                        isLink={true}
                                                        onModalRender={(m, c) => {
                                                            this.setState({ modal: m }, c)
                                                        }}
                                                        onClick={this.archive}
                                                        identifier={this.state.priceList.attributes.identifier}
                                                        className="dropdown-item text-danger"
                                                        message={
                                                            <span>
                                                                <FormattedMessage
                                                                    id="price_list.analytics.delete_warning"
                                                                    defaultMessage="Are you sure you want to delete {priceList} {identifier} ?"
                                                                    values={{
                                                                        identifier: this.state.priceList.attributes.identifier,
                                                                        priceList: getPriceListName(this.props.intl)
                                                                    }}
                                                                />
                                                            </span>
                                                        }
                                                    >
                                                        <Icon value={"trash"} className={"mr-1"} />
                                                        <FormattedMessage
                                                            id="price_list.analytics.delete_btn"
                                                            defaultMessage="Delete"
                                                        />
                                                    </ConfirmButton>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            {this.canBeInvoiced() && (
                                                <ButtonWrapper
                                                    module={Features.Invoice}
                                                    onClick={e => this.openInvoiceCreationModal(e)}
                                                    redirectToAccount={!AppContext.accountFeatureIsEnabled(Features.Invoice)}
                                                    message={
                                                        GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ? (
                                                            <FormattedMessage
                                                                id="listing.search.invoice_document_limit"
                                                                defaultMessage="Documents limit exceeded."
                                                            />
                                                        ) : (
                                                            ""
                                                        )
                                                    }
                                                    className={"btn btn-primary mr-2 mb-2"}
                                                    protectedClassName={"btn btn-primary mr-2 mb-2"}
                                                    tooltipPosition={"top"}
                                                    premium={false}
                                                    protectionRule={
                                                        AppContext.accountFeatureIsEnabled(Features.Invoice) &&
                                                        !GlobalHelper.isAccountLimitExceeded(this.state.accountLimit)
                                                    }
                                                >
                                                    <Icon value={"invoice"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="quote.analytics.create_invoice_btn"
                                                        defaultMessage="Create invoice"
                                                    />
                                                </ButtonWrapper>
                                            )}

                                            {canActivate && (
                                                <ActionButton onClick={this.activate} className={"btn-success btn mr-2 mb-2"}>
                                                    <Icon value={"toggle-on"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="price_list.analytics.activate_btn"
                                                        defaultMessage="Activate"
                                                    />
                                                </ActionButton>
                                            )}

                                            {["active"].includes(this.state.priceList.attributes.status) && (
                                                <>
                                                    <ActionButton
                                                        onClick={this.deactivate}
                                                        className={"btn-warning btn mr-2 mb-2"}
                                                    >
                                                        <Icon value={"toggle-off"} className={"mr-1"} />
                                                        <FormattedMessage
                                                            id="price_list.analytics.deactivate_btn"
                                                            defaultMessage="Deactivate"
                                                        />
                                                    </ActionButton>

                                                    {this.state.priceList.attributes.numberOfOrders > 0 && (
                                                        <ActionButton
                                                            onClick={this.markAsDone}
                                                            className={"btn-success btn mr-2 mb-2"}
                                                        >
                                                            <Icon value={"bullseye"} className={"mr-1"} />
                                                            <FormattedMessage
                                                                id="price_list.analytics.mark_as_completed_btn"
                                                                defaultMessage="Mark as completed"
                                                            />
                                                        </ActionButton>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        <p className="text-align-right text-warning m-0">
                                            <FormattedMessage
                                                id="price_list.analytics.archived_price_list"
                                                defaultMessage="This {priceList} is archived and can't be found in search results."
                                                values={{
                                                    priceList: getPriceListName(this.props.intl)
                                                }}
                                            />
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 px-0 mt-4">
                    <OrderAttemptSection priceListId={priceList.getId()} />
                </div>
            </div>
        )
    }
}

const mapState = (state, props) => {
    return { ...props }
}
const mapDispatch = { updatePriceList }
export default connect(mapState, mapDispatch)(injectIntl(PriceListAnalytics))



// WEBPACK FOOTER //
// ./src/price-list/analytics.component.jsx